import React, { Component } from 'react';
import PropTypes from 'prop-types';

class CourseOption extends Component {
  constructor (props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);

    this.state = {
      selectedCourseId: 0,
      selectedCourse: {},
      course: {},
      qualCourse: {},
      redirect: false
    };
  }

  componentWillReceiveProps () {
    if (this.props.checkoutState.courses.length > 0) {
      // set selected state
      const newState = this.state;
      newState.selectedCourseId = this.props.checkoutState.course.id;
      newState.selectedCourse = this.props.checkoutState.courses.find(
        (c) => c.id === newState.selectedCourseId
      );
      // if the course we are currently scheduled to start is a training course
      // then we need to get the qualification version of the course
      if (this.props.checkoutState.course.category === 'training') {
        newState.course = this.props.checkoutState.courses.find(
          (c) => c.id === newState.selectedCourseId
        );
        newState.qualCourse = this.props.checkoutState.courses.find(
          (c) => (c.level === this.props.checkoutState.course.level && c.category !== 'training')
        );
      } else {
        // if the course we are currently scheduled to start is a qual course
        // then we need to get the training version of the course
        newState.qualCourse = this.props.checkoutState.courses.find(
          (c) => c.id === newState.selectedCourseId
        );
        newState.course = this.props.checkoutState.courses.find(
          (c) => (c.level === this.props.checkoutState.course.level && c.category === 'training')
        );
      }
      this.setState(newState);
    }
  }

  onChange (e) {
    const newState = this.state;
    newState.selectedCourseId = parseInt(e.currentTarget.value, 10);
    newState.selectedCourse = this.props.checkoutState.courses.find(
      (c) => c.id === newState.selectedCourseId
    );
    this.setState(newState);
  }

  applyState (selectedCourse) {
    const stepState = {};
    stepState.course = selectedCourse;
    stepState.course.price = selectedCourse.courseOptions[0].price;
    stepState.course.instalmentPrice = selectedCourse.courseOptions[0].instalmentPrice;
    stepState.course.instalmentDurationMonths = selectedCourse.courseOptions[0].instalmentDurationMonths;
    return stepState;
  }

  onSubmit (e) {
    e.preventDefault();
    const stepState = this.applyState(this.state.selectedCourse);
    this.props.onSubmit(1, stepState);

    /* -- for when there was a waiting list
    if (this.state.selectedCourse.type === 'independent' ||
    this.state.selectedCourse.title.indexOf('Level 1') > -1) {
      this.props.onSubmit(1, stepState);
    } else {
      this.props.onSubmit(3, stepState);
    } -- */

  }

  render () {
    return (
      <form action='' className='checkout__form checkout__form--payment-type'>
        <h2>Course option</h2>
        <ul className='form-fields simple-inputs'>
          <li>
            <label className='control radio'>
              <input id='oneOff' name='selectedCourse' type='radio' value={this.state.course.id} checked={this.state.selectedCourseId === this.state.course.id} onChange={this.onChange} />
              <span className='control-indicator' />
              I don't require a qualification at this level
              <p className='label-extra label-extra--always-show'>{this.state.course.title}</p>
            </label>
          </li>
          <li>
            <label className='control radio'>
              <input id='instalments' name='selectedCourse' type='radio' value={this.state.qualCourse.id} checked={this.state.selectedCourseId === this.state.qualCourse.id} onChange={this.onChange} />
              <span className='control-indicator' />
              I require an iBSL Certificate qualification
              <p className='label-extra label-extra--always-show'>{this.state.qualCourse.title}</p>
            </label>
          </li>
          <li className='form-footer'>
            <a onClick={this.onSubmit} className='button button--l'>Next</a>
          </li>
        </ul>
      </form>
    );
  }
}

CourseOption.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  checkoutState: PropTypes.object.isRequired
};

export default CourseOption;



// WEBPACK FOOTER //
// ./src/views/Checkout/CourseOption/index.js